/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time == 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}


/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0;
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1;
    } else { len += 0.5; }
  }
  return Math.floor(len);
}

export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

export function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key]);
  })).join('&');
}

export function param2Obj(url) {
  const search = url.split('?')[1];
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export function html2Text(val) {
  const div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

export function objectMerge(target, source) {
  /* Merges two  objects,
   giving the last one precedence */

  if (typeof target !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  for (const property in source) {
    if (source.hasOwnProperty(property)) {
      const sourceProperty = source[property];
      if (typeof sourceProperty === 'object') {
        target[property] = objectMerge(target[property], sourceProperty);
        continue;
      }
      target[property] = sourceProperty;
    }
  }
  return target;
}


export function scrollTo(element, to, duration) {
  if (duration <= 0) return;
  const difference = to - element.scrollTop;
  const perTick = difference / duration * 10;
  setTimeout(() => {
    console.log(new Date())
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  }, 10);
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date();
      const start = new Date(new Date().toDateString());
      end.setTime(start.getTime());
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit('pick', [start, end]);
    }
  }]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}


export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone');
  }
  const targetObj = source.constructor === Array ? [] : {};
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        if (Object.prototype.toString.call(source[keys]) === '[object Date]') {
          targetObj[keys] = new Date(source[keys].getTime())
        } else {
          targetObj[keys] = source[keys].constructor === Array ? [] : {};
          targetObj[keys] = deepClone(source[keys]);
        }
      } else {
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}

export function JsonWebSocket(url) {
  this.ws = null;
  let packetId = 0;
  const callbackTable = [];
  const selfApi = {};

  this.taskId = null;

  // 是否连接
  this.connected = false;

  // 关闭时触发
  this.onclose = function(e) {
  };

  // 握手成功后触发
  this.onopen = function(e) {
  };

  function isFunction(func) {
    return !!func && typeof func === 'function';
  }

  // 绑定给服务器来调用的api，返回是否绑定成功
  // name：api名称
  // func: api实现函数
  this.bindApi = function(name, func) {
    if (typeof name !== 'string' || !name || !isFunction(func)) {
      return false;
    }
    selfApi[name.toLowerCase()] = func;
    return true;
  }

  // 调用服务器实现api，返回是否可以正常调用
  // api：远程端api名，不区分大小写
  // parameters：参数值数组，注意参数顺序(可选)
  // doneFunc：服务端返回api结果后触发的回调(可选)
  // exFunc：服务端返回异常信息后触发的回调(可选)
  this.invokeApi = function(api, parameters, doneFunc, exFunc) {
    if (this.connected === false) {
      return false;
    }
    packetId = packetId + 1;
    const packet = { api, packetId, body: parameters || [] };
    const json = JSON.stringify(packet);

    if (isFunction(doneFunc) || isFunction(exFunc)) {
      callbackTable.push({ packetId, callback: { doneFunc, exFunc } });
    }
    this.ws.send(json);
    return true;
  };

  // 获取回调
  function getCallback(id) {
    for (let i = 0; i < callbackTable.length; i++) {
      const item = callbackTable[i];
      if (item.packetId === parseInt(id)) {
        callbackTable.splice(i, 1);
        return item.callback;
      }
    }
  }

  // 将异常信息发送到服务端
  function setRemoteException(packet, message) {
    packet.state = false;
    packet.body = message;
    const json = JSON.stringify(packet);
    this.ws.send(json);
  }

  // 将api调用结果发送到服务端
  function setApiResult(packet, result) {
    packet.body = result;
    const json = JSON.stringify(packet);
    this.ws.send(json);
  }

  // 调用自身实现的api
  function callApi(packet) {
    const api = selfApi[packet.api.toLowerCase()];
    if (!isFunction(api)) {
      setRemoteException(packet, '请求的api不存在：' + api);
      return;
    }

    try {
      const result = api.apply(this, packet.body);
      console.log(result)
      if (result !== undefined) {
        setApiResult(packet, result);
      }
    } catch (ex) {
      setRemoteException(packet, ex.message);
    }
  }

  // 收到文本消息时
  function onmessage(e) {
    const packet = JSON.parse(e.data);
    // if (!packet.fromClient) {
    //   callApi.apply(this, [packet]);
    //   return;
    // }
    const callback = getCallback(packet.PacketId);
    if (!callback) {
      return;
    }
    if (isFunction(callback.doneFunc)) {
      callback.doneFunc(packet);
    }
  }

  // 初始化
  function init() {
    const $this = this;
    this.ws = new (window.WebSocket || window.MozWebSocket)(url);
    this.ws.onclose = function(e) {
      $this.connected = false;
      $this.onclose(e);
      setTimeout(init.apply($this), 3000);
    };
    this.ws.onopen = function(e) {
      $this.connected = true;
      $this.onopen(e);
    };
    this.ws.onmessage = function(e) {
      onmessage.apply($this, [e]);
    };
  }

  init.apply(this);
}



// WEBPACK FOOTER //
// ./src/utils/index.js